<template>
  <div class="flex flex-col h-full">
    <DashboardHeader title="Create New Job Posting" link="/jobs/create-new" is-edit />

    <div class="flex w-full flex-1 overflow-y-auto">
      <JobForm />
    </div>
  </div>
</template>

<script setup lang="ts">
import JobForm from '@/components/jobs/JobForm.vue'
import DashboardHeader from '@/components/common/DashboardHeader.vue'
</script>
